import axios, { AxiosInstance } from 'axios'
import Configuration from '../domain/Configuration'

export default class WallexService {
    static instance(): AxiosInstance {
        return axios.create({
            baseURL: Configuration.BASE_URL,
            headers: {
                region: localStorage.getItem('region') || 'SG',
            },
        })
    }
}
